<template>
  <div class="marg-20-top weekplan">
    <div class="box">
      <h2 class="marg-20-bottom">{{ $t('calendars.week_plan_and_note.week_plan')}}</h2>
      <div class="week_note" v-if="weekNote !== undefined && weekNote.length">
        <div class="week_note__content" v-html="weekNoteWithLineBreaks"></div>
      </div>
      <ul>
        <template v-for="day in eventsWithNotes">
          <li class="day_change" v-if="day.lessons.length !== 0">
            <div class="day_change_header">
              <h3>{{ $filters.capitalize(createLocaleDate(day.date)) }}</h3>
            </div>
            <div class="grid grid grid-responsive">
              <div class="col-2-12 box-size">
                <b>{{ $t('calendars.week_plan.subject') }}</b>
              </div>
              <div class="col-10-12">
                <div class="col-1-3">
                  <p><b>{{ $t('calendars.week_plan.learning_goal') }}</b></p>
                </div>
                <div class="col-1-3">
                  <p><b>{{ $t('calendars.week_plan.content') }} </b></p>
                </div>
                <div class="col-1-3">
                  <p><b>{{ $t('calendars.week_plan.pupil_preparation') }}</b></p>
                </div>
              </div>
            </div>
            <template v-for="event in day.lessons">
              <d-week-plan-lesson
                :event="event"
                :date="date">
              </d-week-plan-lesson>
            </template>
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
  import dWeekPlanLesson from './WeekPlanLesson'

  import moment from 'moment'  // eslint-disable-line no-unused-vars
  import docendo from '../../../../docendo'

  export default {
    props: {
      events: {},
      calId: {},
      date: {
        default: moment().utc()
      },
      calview: {},
      locale: {}
    },
    data () {
      return {
        weekNote: ''
      }
    },
    watch: {
      date () {
        this.getWeekNote()
        this.createLocaleDate(this.date)
      }
    },
    components: {
      dWeekPlanLesson
    },
    computed: {
      weekNoteWithLineBreaks () {
        return this.weekNote.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      },
      eventsWithNotes () {
        let allDates = []
        for (let i = 1; i < 8; i++) {
          let date = moment(this.date).isoWeekday(i).locale('en').format('YYYY-MM-DD')
          let arr = this.filterLesson(i).concat()
          arr.sort(function compare (a, b) {
            var dateA = new Date(a.start)
            var dateB = new Date(b.start)
            return dateA - dateB
          })
          allDates.push({date, lessons: arr})
        }
        return allDates
      }
    },
    methods: {
      createLocaleDate (mom) {
        // NN hack
        if (this.locale === 'nn') {
          return moment(mom).format('dddd DD. MMMM')
        }
        try {
          return moment(mom)._d.toLocaleDateString(this.locale, {weekday: 'long', month: 'long', day: '2-digit'})
        } catch (e) {
          return moment(mom).format('LL')
        }
      },
      getWeekNote () {
        let isoWeek = moment(this.date).isoWeek().toString().length < 2 ? '0' + moment(this.date).isoWeek() : moment(this.date).isoWeek()
        let week = moment(this.date).endOf('week').locale('en').format('YYYY') + 'W' + isoWeek
        docendo.weeknote(this.calId, week, (data) => {
          this.weekNote = data.note
        })
      },
      filterLesson (dayNum) {
        return this.events.filter(lesson => {
          let lessonDate = moment(lesson.start).locale('en').format('YYYY-MM-DD')
          let day = moment(this.date).isoWeekday(dayNum).locale('en').format('YYYY-MM-DD')
          return moment(lessonDate).isSame(day) && lesson.has_notes
        })
      }
    },
    mounted () {
      this.getWeekNote()
    }
  }
</script>

<style scoped>
  #header {
    font-size: 16px;
    padding: 10px 20px;
  }

  .day_change {
    padding-bottom: 10px;
    margin-bottom: 10px;
  }

  .day_change_header {
    padding: 5px 0 5px 0;
    margin-bottom: 5px;
  }

  .day_change > .grid {
    padding: 5px 20px;
  }

  .week_note {
    font-size: 13px;
    background: #f6f7f8;
    border-left: 3px solid #f6f7f8;
    border-radius: 3px;
    overflow: hidden;
    padding: 10px 20px;
    margin-bottom: 10px;
  }

  .week_note__content ul, .week_note__content ol {
    margin-left: 20px;
    padding-left: 1.5em;
  }

  .week_note__content ul li {
    list-style-type: disc;
  }

  .week_note__content ol li {
    list-style-type: decimal;
  }

  @media print {
    .weekplan.hide {
      display: none !important;
    }

    .weekplan:not(.hide) {
      page-break-before: always;
    }
  }

</style>



// WEBPACK FOOTER //
// WeekPlan.vue?7b030c38